import { useSelector } from 'react-redux';
import { Typography } from '@interstate/components/Typography';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import { joinNonEmptyStringParts } from '@makemydeal/dr-dash-ui-utils';
import {
    StyledVehicleContainer,
    StyledVehicleSubContainer,
    StyledVehicleInfo,
    VehicleInfoCardBaseSeparator,
    StyledVehicleImage
} from './Vehicle.style';
import VehicleImage from './VehicleImage';

const VehicleInfoCard = () => {
    const theme = useInterstateTheme();
    const { condition, make, model, stockNumber, trim, vin, year, imageUrl } = useSelector(vehicleSelectors.getVehicle);
    const vehicleInfoTitle = joinNonEmptyStringParts(condition, year, make, model, trim);
    const stockLabel = `Stock #${stockNumber || ''}`;

    return (
        <StyledVehicleContainer theme={theme}>
            <StyledVehicleImage>
                <VehicleImage src={imageUrl} />
            </StyledVehicleImage>
            <StyledVehicleSubContainer>
                <Typography sx={{ textTransform: 'capitalize', fontSize: '22px', fontWeight: 700 }} variant="h2">
                    {vehicleInfoTitle}
                </Typography>
                <StyledVehicleInfo theme={theme}>
                    <Typography variant="body-sm">
                        {vin}
                        <VehicleInfoCardBaseSeparator
                            theme={theme}
                            data-testid="vehicle-info-card_separator"
                        ></VehicleInfoCardBaseSeparator>
                    </Typography>
                    <Typography variant="body-sm">{stockLabel}</Typography>
                </StyledVehicleInfo>
            </StyledVehicleSubContainer>
        </StyledVehicleContainer>
    );
};

export default VehicleInfoCard;
